import axios from "axios";
import { isBrowser } from "../util/env-utils";
declare const IA_KEY: string;

const getBaseUrl = () => {
  if (
    isBrowser &&
    typeof window.PROXY_ENDPOINT !== "undefined" &&
    typeof window.IA_MIDDLEWARE_PROXY_PATH !== "undefined"
  ) {
    return `${window.PROXY_ENDPOINT}/api/${window.IA_MIDDLEWARE_PROXY_PATH}/v1/proxy`;
  }

  return "";
};

export const CONVERSATION_STORAGE_KEY = "conversationId:v2";

export async function getIAAudioReponse(
  messageId: string,
  iaText: string
): Promise<{ text: string; audioUrl: string | null }> {
  try {
    const ttsResponse = await axios.post(
      `${getBaseUrl()}/tts/${encodeURIComponent(messageId)}`,
      undefined,
      { responseType: "blob" }
    );

    const audioBlob: any = ttsResponse.data;
    const audioUrl = URL.createObjectURL(audioBlob);

    return {
      text: iaText,
      audioUrl,
    };
  } catch (error: any) {
    error.message = `Error to get audio response: ${error}`;
    throw error.message;
  }
}

async function ensureConversationId(
  conversationId?: string | null | undefined
): Promise<string | null | undefined> {
  if (!conversationId) {
    conversationId = await getConversationId();

    const newConversationRequisition = await createIAConversation();

    if (newConversationRequisition?.status === 201) {
      conversationId = newConversationRequisition?.data?.id;
    }
  }

  return conversationId;
}

export async function getIAResposta(
  text: string,
  conversationId?: string | null | undefined,
  accessToken?: string | null | undefined
): Promise<{ text: any; messageId: string | undefined }> {
  conversationId = await ensureConversationId(conversationId);

  const response = await axios.post(
    `${getBaseUrl()}/conversation/stream/${conversationId}`,
    { text: text },
    {
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    }
  );

  return {
    text: response?.data,
    messageId: response?.headers?.["x-custom-info"],
  };
}

export async function createIAConversation(): Promise<any> {
  const response = await axios.post(
    `${getBaseUrl()}/conversation/create`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response;
}

export async function getConversationId(): Promise<string | undefined> {
  const isCurrentSessionValid = checkConversationSessionLifetime();

  if (isCurrentSessionValid) {
    const conversationIdSession = localStorage.getItem(
      CONVERSATION_STORAGE_KEY
    );
    if (conversationIdSession) {
      const conversationData = JSON.parse(conversationIdSession);

      return conversationData.conversationId;
    }
  }
  const newConversationRequisition = await createIAConversation();

  if (newConversationRequisition?.status === 201) {
    const conversationId = newConversationRequisition?.data?.id;

    if (conversationId) {
      renewConversationSession(conversationId);
    }

    return conversationId;
  }
}

function checkConversationSessionLifetime(): boolean {
  const conversationIdSession = localStorage.getItem(CONVERSATION_STORAGE_KEY);

  if (conversationIdSession) {
    const conversationData = JSON.parse(conversationIdSession || "{}");

    if (conversationData.timeStamp) {
      const currentTime = Date.now();
      const timeDifference = currentTime - conversationData.timeStamp;

      const sessionLifetime = 24 * 60 * 60 * 1000; // 24h in milliseconds

      return timeDifference < sessionLifetime;
    }
    return false;
  }

  return false;
}

function renewConversationSession(conversationId: string): void {
  const conversationData = {
    conversationId: conversationId,
    timeStamp: Date.now(),
  };

  localStorage.setItem(
    CONVERSATION_STORAGE_KEY,
    JSON.stringify(conversationData)
  );
}

// TODO: Utilizar esta API call para coletar feedback do usuário
export async function sendFeedback(
  conversationId: string,
  feedback: number
): Promise<any> {
  try {
    const response = await axios.post(
      `${getBaseUrl()}/conversation/survey/${conversationId}`,
      { nota: feedback },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${IA_KEY}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    console.error("Erro ao enviar feedback:", error);
    throw error;
  }
}
